export const SIDEBAR_WIDTH = 300;
export const MIN_SIDEBAR_WIDTH = 70;
